import { useState } from "react";
import { useTranslation } from "react-i18next";
import SearchResultItem from "./SearchResultItem";

const ITEMS_PER_PAGE = 10;

const FullListResults = ({
  items,
  category,
  onItemClick,
  searchQuery = "",
}) => {
  const { t } = useTranslation();
  const [currentPage] = useState(1);

  const categoryLabel =
    {
      customers: t("globalSearch.categories.customers"),
      entities: t("globalSearch.categories.entities"),
      invoices: t("globalSearch.categories.invoices"),
      projects: t("globalSearch.categories.projects"),
      properties: t("globalSearch.categories.properties"),
      units: t("globalSearch.categories.units"),
      vouchers: t("globalSearch.categories.vouchers"),
      lead_contacts: t("globalSearch.categories.leadContacts"),
      contracts: t("globalSearch.categories.contracts"),
      products: t("globalSearch.categories.products"),
      support_center: t("globalSearch.categories.supportCenter"),
      unit_messages: t("globalSearch.categories.unitMessages"),
    }[category] || "";

  const totalItems = items?.length || 0;
  const startIndex = 0;
  const endIndex = currentPage * ITEMS_PER_PAGE;
  const displayedItems = items?.slice(startIndex, endIndex) || [];

  if (totalItems === 0) {
    return (
      <div className="py-8 text-center text-text-muted">
        {t("globalSearch.noResults")}
      </div>
    );
  }

  return (
    <div className="space-y-4 min-w-0">
      <div className="flex items-center justify-between min-w-0">
        <h3 className="text-[#2F2D38] text-base font-semibold flex items-center gap-2 min-w-0 truncate">
          {categoryLabel}{" "}
          <span className="bg-[#F8F8F8] text-[#A3A5B4] px-2 py-0.5 rounded-full text-xs font-normal shrink-0">
            {totalItems}
          </span>
        </h3>
      </div>
      <div className="space-y-1 max-h-[400px] overflow-y-auto overflow-x-hidden min-w-0">
        {displayedItems.map((item) => (
          <SearchResultItem
            key={item.id}
            item={item}
            category={category}
            onClick={onItemClick}
            searchQuery={searchQuery}
          />
        ))}
      </div>
    </div>
  );
};

export default FullListResults;
